/*
 * This file is part of glowingblue/orell-rezensionen.
 *
 * Copyright (c) 2023 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import Dropdown from 'flarum/common/components/Dropdown';
import Post from 'flarum/forum/components/Post';
import ReviewPostControls from '../utils/ReviewPostControls';
import PostControls from 'flarum/forum/utils/PostControls';
import { utils } from '@glowingblue-orell-thalia-common';
import type Mithril from 'mithril';

const { findChild } = utils.vdom;
import type { VdomParent } from '@glowingblue-orell-thalia-common/utils/vdom';

/**
 * Swaps in ReviewPostControls wherever a review's posts are rendered.
 */
export default function () {
	extend(Post.prototype, 'view', function (vnode) {
		const { post } = this.attrs;
		if (post.discussion().isReview()) {
			const reviewControls = ReviewPostControls.controls(post, this);
			const postControls = PostControls.controls(post, this);
			postControls.merge(reviewControls);
			const controls = postControls.toArray();

			// `findChild` returns the generic vdom shape; narrowed to what this mutation relies on.
			const postActions = findChild(vnode as VdomParent, 'Post-actions', true) as { children: Mithril.Vnode<any>[] } | null;
			if (postActions && controls.length) {
				const listItems = postActions.children[0].children as Mithril.ChildArray;
				listItems[listItems.length - 1] = (
					<li>
						<Dropdown
							className="Post-controls"
							buttonClassName="Button Button--icon Button--flat"
							menuClassName="Dropdown-menu--right"
							icon="fas fa-ellipsis-h"
							onshow={() => this.$('.Post-actions').addClass('open')}
							onhide={() => this.$('.Post-actions').removeClass('open')}
							accessibleToggleLabel={app.translator.trans('core.forum.post_controls.toggle_dropdown_accessible_label')}
						>
							{controls}
						</Dropdown>
					</li>
				);
			}
		}
	});
}
